import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/form/Input';
import { ThemeMode } from '@/helpers/enums';

import { ScPromoCodeInput } from '@/components/Deposit/components/InputPromo/styled';

const REG_BONUS_CODE_FIELD = 'registrationBonusCode';

export const RegistrationPromoInput: FC = () => {
  const { t } = useTranslation();

  return (
    <ScPromoCodeInput mode={ThemeMode.Light}>
      <Input
        name={REG_BONUS_CODE_FIELD}
        placeholder={t('deposits:inputPromo.placeholder')}
        mode={ThemeMode.Light}
      />
    </ScPromoCodeInput>
  );
};
